import React from 'react';
import { ChevronRight } from 'lucide-react';
import { IITH, SANS } from './iithBrand';

export default function LandingNav({ name, logo, primary, gotoLogin, onAppointments, showAbout }) {
  const accent = primary || IITH.saffron;
  const goAppointments = (e) => {
    e.preventDefault();
    if (onAppointments) onAppointments();
    else document.getElementById('book-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="sticky top-0 z-30 border-b border-white/10 bg-[#071B34]/90 backdrop-blur-xl">
      <div className="max-w-6xl mx-auto px-5 sm:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <img
            src={logo || '/assets/iith-logo.png'}
            alt={name || IITH.hospital}
            className="h-10 w-10 object-contain flex-shrink-0 bg-white/95 rounded-full p-1 shadow-md"
          />
          <div className="min-w-0 leading-tight">
            <p className="font-semibold text-white text-sm tracking-tight truncate" style={{ fontFamily: SANS }}>
              {name || IITH.hospital}
            </p>
            <p className="text-[10px] text-[#9AADBE] tracking-wide truncate hidden sm:block">
              {IITH.institute}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-0.5 sm:gap-1">
          <a
            href="#book-section"
            onClick={goAppointments}
            className="inline-flex text-xs font-semibold text-white px-2.5 py-1.5 rounded-sm hover:brightness-110"
            style={{ background: `${accent}33`, color: accent }}
            data-testid="nav-appointments"
          >
            Appointments
          </a>
          <a href="#specialties" className="hidden sm:inline-flex text-xs text-[#9AADBE] hover:text-white px-2.5 py-1.5">
            Specialties
          </a>
          <a href="#doctors" className="hidden md:inline-flex text-xs text-[#9AADBE] hover:text-white px-2.5 py-1.5">
            Doctors
          </a>
          {showAbout && (
            <a href="#about" className="hidden md:inline-flex text-xs text-[#9AADBE] hover:text-white px-2.5 py-1.5">
              About
            </a>
          )}
          <a
            href="/register"
            className="hidden sm:inline-flex text-xs text-[#9AADBE] hover:text-white px-2.5 py-1.5"
            data-testid="nav-register"
          >
            Register
          </a>
          <button
            type="button"
            onClick={gotoLogin}
            className="ml-1 text-xs font-semibold text-white px-3.5 py-2 rounded-sm hover:brightness-110 transition"
            style={{ background: accent }}
            data-testid="nav-staff-login"
          >
            Staff portal <ChevronRight className="inline h-3 w-3" />
          </button>
        </div>
      </div>
    </nav>
  );
}
